import { render, staticRenderFns } from "./CreateGupshupChannel.vue?vue&type=template&id=82045ab4&scoped=true"
import script from "./CreateGupshupChannel.vue?vue&type=script&lang=js"
export * from "./CreateGupshupChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateGupshupChannel.vue?vue&type=style&index=0&id=82045ab4&prod&lang=scss&scoped=true"
import style1 from "./CreateGupshupChannel.vue?vue&type=style&index=1&id=82045ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82045ab4",
  null
  
)

export default component.exports